import { render, staticRenderFns } from "./traige.vue?vue&type=template&id=736ddab8&scoped=true"
import script from "./traige.vue?vue&type=script&lang=js"
export * from "./traige.vue?vue&type=script&lang=js"
import style0 from "./traige.vue?vue&type=style&index=0&id=736ddab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ddab8",
  null
  
)

export default component.exports